module.exports = __webpack_public_path__ + "static/media/logo-3.db201fb2.png";